import React, { useEffect, useState } from 'react';
import '../../styles/dept-sports/main.css';
import "@fancyapps/ui/dist/fancybox/fancybox.css"; // Correct path for FancyBox 4
import { Fancybox } from "@fancyapps/ui";

const Main = () => {
    const [activeTab, setActiveTab] = useState('tabsBtnClick');

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };


    // Initialize FancyBox after component mounts
    useEffect(() => {
        Fancybox.bind("[data-fancybox='gallery']", {
            infinite: false,
            loop: true,
        });
    }, []);

    return (
        <div id='deptsportsMain'>
            <div className="dept-sports">
                <div className="container border rounded">
                    <h3 className="my-heading pt-5 pb-4">Department of Sports</h3>
                    {/* <button className="btn btn-primary float-right">No. of Seats</button> */}
                    {/* <br> */}
                    <ul className="nav nav-tabs">
                        <li className="nav-item about-tab">
                            <button className={`nav-link ${activeTab === 'tabsBtnClick' ? 'active' : ''}`}
                                onClick={() => handleTabClick('tabsBtnClick')}>
                                About
                            </button>
                        </li>
                        <li className="nav-item">
                            <button className={`nav-link ${activeTab === 'tabsBtnClick1' ? 'active' : ''}`}
                                onClick={() => handleTabClick('tabsBtnClick1')}>
                                Range of Sports
                            </button>
                        </li>
                        <li className="nav-item">
                            <button className={`nav-link ${activeTab === 'tabsBtnClick2' ? 'active' : ''}`}
                                onClick={() => handleTabClick('tabsBtnClick2')}>
                                Faculty
                            </button>
                        </li>
                        <li className="nav-item">
                            <button className={`nav-link ${activeTab === 'tabsBtnClick3' ? 'active' : ''}`}
                                onClick={() => handleTabClick('tabsBtnClick3')}>
                                Syllabus
                            </button>
                        </li>
                        <li className="nav-item">
                            <button className={`nav-link ${activeTab === 'tabsBtnClick4' ? 'active' : ''}`}
                                onClick={() => handleTabClick('tabsBtnClick4')}>
                                Faculties
                            </button>
                        </li>
                        <li className="nav-item">
                            <button className={`nav-link ${activeTab === 'tabsBtnClick5' ? 'active' : ''}`}
                                onClick={() => handleTabClick('tabsBtnClick5')}>
                                Cash Award and Incentive
                            </button>
                        </li>
                        <li className="nav-item">
                            <button className={`nav-link ${activeTab === 'tabsBtnClick6' ? 'active' : ''}`}
                                onClick={() => handleTabClick('tabsBtnClick6')}>
                                Annual Report
                            </button>
                        </li>
                        <li className="nav-item">
                            <button className={`nav-link ${activeTab === 'tabsBtnClick7' ? 'active' : ''}`}
                                onClick={() => handleTabClick('tabsBtnClick7')}>
                                Gallery
                            </button>
                        </li>
                        <li className="nav-item">
                            <button className={`nav-link ${activeTab === 'tabsBtnClick8' ? 'active' : ''}`}
                                onClick={() => handleTabClick('tabsBtnClick8')}>
                                Achievements
                            </button>
                        </li>
                        <li className="nav-item">
                            <button className={`nav-link ${activeTab === 'tabsBtnClick9' ? 'active' : ''}`}
                                onClick={() => handleTabClick('tabsBtnClick9')}>
                                Time Table
                            </button>
                        </li>
                        <li className="nav-item">
                            <button className={`nav-link ${activeTab === 'tabsBtnClick10' ? 'active' : ''}`}
                                onClick={() => handleTabClick('tabsBtnClick10')}>
                                MoU
                            </button>
                        </li>
                        <li className="nav-item">
                            <button className={`nav-link ${activeTab === 'tabsBtnClick11' ? 'active' : ''}`}
                                onClick={() => handleTabClick('tabsBtnClick11')}>
                                News
                            </button>
                        </li>
                        <li className="nav-item">
                            <button className={`nav-link ${activeTab === 'tabsBtnClick12' ? 'active' : ''}`}
                                onClick={() => handleTabClick('tabsBtnClick12')}>
                                Sports Council
                            </button>
                        </li>
                    </ul>

                    <div className="tab-content">

                        <div className={`tab-pane fade about ${activeTab === 'tabsBtnClick' ? 'show active' : ''}`} id="tabsBtnClick">
                            <div className="row">
                                <div
                                    className="col-md-4 col-12 photo"
                                    style={{
                                        borderTopLeftRadius: 25,
                                        borderBottomLeftRadius: 25,
                                        boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                                    }}
                                >
                                    {/* Photo */}
                                    <div
                                        id="carouselExampleIndicators"
                                        className="carousel slide"
                                        data-bs-ride="carousel"
                                    >
                                        <div className="carousel-indicators">
                                            <button
                                                type="button"
                                                data-bs-target="#carouselExampleIndicators"
                                                data-bs-slide-to={0}
                                                className="active"
                                                aria-current="true"
                                                aria-label="Slide 1"
                                            />
                                            <button
                                                type="button"
                                                data-bs-target="#carouselExampleIndicators"
                                                data-bs-slide-to={1}
                                                aria-label="Slide 2"
                                            />
                                        </div>
                                        <div className="carousel-inner">
                                            <div className="carousel-item active">
                                                <img
                                                    src="./assets/images/dept-sports/ds-pic-1.jpg"
                                                    className="d-block w-100"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="carousel-item">
                                                <img
                                                    src="./assets/images/dept-sports/ds-pic-2.jpg"
                                                    className="d-block w-100"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                        <button
                                            className="carousel-control-prev"
                                            type="button"
                                            data-bs-target="#carouselExampleIndicators"
                                            data-bs-slide="prev"
                                        >
                                            <span
                                                className="carousel-control-prev-icon"
                                                aria-hidden="true"
                                            />
                                            <span className="visually-hidden">Previous</span>
                                        </button>
                                        <button
                                            className="carousel-control-next"
                                            type="button"
                                            data-bs-target="#carouselExampleIndicators"
                                            data-bs-slide="next"
                                        >
                                            <span
                                                className="carousel-control-next-icon"
                                                aria-hidden="true"
                                            />
                                            <span className="visually-hidden">Next</span>
                                        </button>
                                    </div>
                                    <div className="ds-video">
                                        <video width="100%" height={240} controls="">
                                            <source
                                                src="./assets/images/dept-sports/ccsum-sports-main.mp4"
                                                type="video/mp4"
                                            />
                                        </video>
                                        <span>
                                            North Zone Interuniversity Kho-Kho Men Tournament 2022-23
                                        </span>
                                    </div>
                                </div>
                                <div className="col-md-8 col-12">
                                    {/* Content Columns */}
                                    <div className="row">
                                        <div className="col overview overview-content">
                                            {/* Department Overview */}
                                            <h2 style={{ fontSize: 18, color: "black" }}>
                                                Department Overview
                                            </h2>
                                            <h2 style={{ fontSize: 15, lineHeight: "10px", display: "block" }}>
                                                Head of Department: Dr. G. S. Ruhal
                                            </h2>
                                            <p style={{ fontSize: 13, paddingTop: 10 }}>
                                                Since the inception of the University, due emphasis was given
                                                for providing opportunity for the talented sports persons of
                                                the University to excel in the field of competitive sports. In
                                                order to inspire and motivate sports Talents, University has
                                                taken adequate measures and implements various schemes such
                                                as;
                                            </p>
                                            <ul>
                                                <li>
                                                    Reservation of seats for outstanding sports persons in all
                                                    UG and PG courses{" "}
                                                </li>
                                                <li>
                                                    Additional sports kit for the outstanding sports persons{" "}
                                                </li>
                                                <li>
                                                    Cash prizes for medal winners in National University
                                                    championships{" "}
                                                </li>
                                                <li>Trophies for inter collegiate champions </li>
                                                <li>
                                                    Over all Championship trophy for best college under the
                                                    University{" "}
                                                </li>
                                                <li>
                                                    Inter collegiate competitions in all the major sports
                                                    disciplines
                                                </li>
                                                <li>Special coaching camps for selected University teams </li>
                                                <li>
                                                    Sending University Teams for Inter University Tournaments
                                                </li>
                                                <li>
                                                    Sending selected University Players for Khelo India
                                                    University Games
                                                </li>
                                                <li>
                                                    Sending selected University Players for World University
                                                    Games/Championships
                                                </li>
                                            </ul>
                                            <p style={{ fontSize: 13, paddingTop: 10 }}>
                                                <strong>Special Programmes for Girls</strong>
                                                <br />A centralized fitness centre was started in the Maharani
                                                Laxmibai Girls Hostel under the mission Shakti to ensure the
                                                participation of women sports talents and to provide them
                                                scientific training for excellence. Outstanding and talented
                                                sports.
                                            </p>
                                        </div>
                                        <div className="col latest-updates latest-updates-content">
                                            {/* Latest Updates */}
                                            <div className="latest-updates-heading">Latest Updates</div>
                                            <div className="l-news">
                                                <p></p>
                                                <p>
                                                    <a
                                                        href="link"
                                                        target="_blank"
                                                        className="pdf-link"
                                                        rel="noreferrer"
                                                    >

                                                    </a>
                                                </p>
                                                <hr />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`tab-pane fade range_sport ${activeTab === 'tabsBtnClick1' ? 'show active' : ''}`} id="tabsBtnClick1">
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <h3>Range of Sports</h3>
                                    <div className="table_divvv">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th colSpan={2}>
                                                        Range of Sports Disciplines in Which Inter-Collegiate
                                                        Tournaments are Conducred
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Archery - Men &amp; Women</td>
                                                    <td>Kabaddi - Men &amp; Women</td>
                                                </tr>
                                                <tr>
                                                    <td>Athletics - Men &amp; Women</td>
                                                    <td>Circle Kabaddi Men &amp; Women</td>
                                                </tr>
                                                <tr>
                                                    <td>Badminton - Men &amp; Women</td>
                                                    <td>Kho - kho-Men &amp; Women</td>
                                                </tr>
                                                <tr>
                                                    <td>Basketball - Men &amp; Women</td>
                                                    <td>Powerlifting - Men &amp; Women</td>
                                                </tr>
                                                <tr>
                                                    <td>Baseball - Men &amp; Women</td>
                                                    <td>Softball - Men &amp; Women</td>
                                                </tr>
                                                <tr>
                                                    <td>Best Physique - Men</td>
                                                    <td>Swimming - Men &amp; Women</td>
                                                </tr>
                                                <tr>
                                                    <td>Boxing – Men &amp; Women</td>
                                                    <td>Table tennis - Men &amp; Women</td>
                                                </tr>
                                                <tr>
                                                    <td>Chess - Men &amp; Women</td>
                                                    <td>Taekwondo - Men &amp; Women</td>
                                                </tr>
                                                <tr>
                                                    <td>Cricket - Men &amp; Women</td>
                                                    <td>Tennis - Men &amp; Women</td>
                                                </tr>
                                                <tr>
                                                    <td>Cross country - Men &amp; Women</td>
                                                    <td>Tug of War - Men &amp; Women</td>
                                                </tr>
                                                <tr>
                                                    <td>Football - Men</td>
                                                    <td>Volleyball - Men &amp; Women</td>
                                                </tr>
                                                <tr>
                                                    <td>Handball - Men &amp; Women</td>
                                                    <td>Weightlifting - Men &amp; Women</td>
                                                </tr>
                                                <tr>
                                                    <td>Hockey - Men &amp; Women</td>
                                                    <td>Wrestling - Men &amp; Women</td>
                                                </tr>
                                                <tr>
                                                    <td>Gymnastics - Men &amp; Women</td>
                                                    <td>Wushu – Men &amp; Women</td>
                                                </tr>
                                                <tr>
                                                    <td>Judo - Men &amp; Women</td>
                                                    <td>Yoga - Men &amp; Women</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`tab-pane fade faculty ${activeTab === 'tabsBtnClick2' ? 'show active' : ''}`} id="tabsBtnClick2">
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <div className="faculty">
                                        <h3>Faculty</h3>
                                        <p className="cato">Head</p>
                                        <div className="more-boxes row">
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src="../assets/images/dept-sports/gs-ruhal.jpg"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Dr. G. S. Ruhal (Head)</h1>
                                                    <p>Sports Officer (BPE, MPE, M.Phil. Ph.D.)</p>
                                                    <a
                                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/05/R3720220704055817.pdf"
                                                        target="blank"
                                                        className="pdf-link"
                                                        rel="noreferrer"
                                                    >
                                                        View Profile
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="more-boxes row">
                                            <p className="cato">Assistant Professor</p>
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img src="../assets/images/dept-sports/ompal.jpg" alt="" />
                                                </div>
                                                <div className="content">
                                                    <h1>Dr. Ompal (A.P.)</h1>
                                                    <p>Assistant Professor (M.P.Ed., Ph.D.)</p>
                                                    <a href="link" target="blank" className="pdf-link" rel="noreferrer">
                                                        View Profile
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`tab-pane fade syllabus ${activeTab === 'tabsBtnClick3' ? 'show active' : ''}`} id="tabsBtnClick3">
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <h3>Syllabus</h3>
                                    <div className="syllabus_table">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Programme Name</th>
                                                    <th>Download New/ Revised Syllabus</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>--</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a href="link" target="_blank" rel="noreferrer">
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <thead>
                                                <tr>
                                                    <th>Programme Name</th>
                                                    <th>Download Old Syllabus</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>--</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a href="link" target="_blank" rel="noreferrer">
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`tab-pane fade faculties ${activeTab === 'tabsBtnClick4' ? 'show active' : ''}`} id="tabsBtnClick4">
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <div className="">
                                        <h3>Facilities</h3>
                                        <section className="tz-gallery mt-0">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col-sm-12 col-md-4">
                                                        <a
                                                            className="lightbox"
                                                            data-fancybox="gallery"
                                                            href="../assets/images/dept-sports/facilities/sp-01.jpg"
                                                        >
                                                            <img
                                                                src="../assets/images/dept-sports/facilities/sp-01.jpg"
                                                                className="img-fluid"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                    <div className="col-sm-12 col-md-4">
                                                        <a
                                                            className="lightbox"
                                                            data-fancybox="gallery"
                                                            href="../assets/images/dept-sports/facilities/sp-02.jpg"
                                                        >
                                                            <img
                                                                src="../assets/images/dept-sports/facilities/sp-02.jpg"
                                                                className="img-fluid"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                    <div className="col-sm-12 col-md-4">
                                                        <a
                                                            className="lightbox"
                                                            data-fancybox="gallery"
                                                            href="../assets/images/dept-sports/facilities/sp-03.jpg"
                                                        >
                                                            <img
                                                                src="../assets/images/dept-sports/facilities/sp-03.jpg"
                                                                className="img-fluid"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                    <div className="col-sm-12 col-md-4">
                                                        <a
                                                            className="lightbox"
                                                            data-fancybox="gallery"
                                                            href="../assets/images/dept-sports/facilities/sp-04.jpg"
                                                        >
                                                            <img
                                                                src="../assets/images/dept-sports/facilities/sp-04.jpg"
                                                                className="img-fluid"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                    <div className="col-sm-12 col-md-4">
                                                        <a
                                                            className="lightbox"
                                                            data-fancybox="gallery"
                                                            href="../assets/images/dept-sports/facilities/sp-05.jpg"
                                                        >
                                                            <img
                                                                src="../assets/images/dept-sports/facilities/sp-05.jpg"
                                                                className="img-fluid"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                    <div className="col-sm-12 col-md-4">
                                                        <a
                                                            className="lightbox"
                                                            data-fancybox="gallery"
                                                            href="../assets/images/dept-sports/facilities/sp-06.jpg"
                                                        >
                                                            <img
                                                                src="../assets/images/dept-sports/facilities/sp-06.jpg"
                                                                className="img-fluid"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                    <div className="col-sm-12 col-md-4">
                                                        <a
                                                            className="lightbox"
                                                            data-fancybox="gallery"
                                                            href="../assets/images/dept-sports/facilities/sp-07.jpg"
                                                        >
                                                            <img
                                                                src="../assets/images/dept-sports/facilities/sp-07.jpg"
                                                                className="img-fluid"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                    <div className="col-sm-12 col-md-4">
                                                        <a
                                                            className="lightbox"
                                                            data-fancybox="gallery"
                                                            href="../assets/images/dept-sports/facilities/sp-08.jpg"
                                                        >
                                                            <img
                                                                src="../assets/images/dept-sports/facilities/sp-08.jpg"
                                                                className="img-fluid"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                    <div className="col-sm-12 col-md-4">
                                                        <a
                                                            className="lightbox"
                                                            data-fancybox="gallery"
                                                            href="../assets/images/dept-sports/facilities/sp-09.jpg"
                                                        >
                                                            <img
                                                                src="../assets/images/dept-sports/facilities/sp-09.jpg"
                                                                className="img-fluid"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                    <div className="col-sm-12 col-md-4">
                                                        <a
                                                            className="lightbox"
                                                            data-fancybox="gallery"
                                                            href="../assets/images/dept-sports/facilities/sp-010.jpg"
                                                        >
                                                            <img
                                                                src="../assets/images/dept-sports/facilities/sp-010.jpg"
                                                                className="img-fluid"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                    <div className="col-sm-12 col-md-4">
                                                        <a
                                                            className="lightbox"
                                                            data-fancybox="gallery"
                                                            href="../assets/images/dept-sports/facilities/sp-011.jpg"
                                                        >
                                                            <img
                                                                src="../assets/images/dept-sports/facilities/sp-011.jpg"
                                                                className="img-fluid"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                    <div className="col-sm-12 col-md-4">
                                                        <a
                                                            className="lightbox"
                                                            data-fancybox="gallery"
                                                            href="../assets/images/dept-sports/facilities/sp-012.jpg"
                                                        >
                                                            <img
                                                                src="../assets/images/dept-sports/facilities/sp-012.jpg"
                                                                className="img-fluid"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                    <div className="col-sm-12 col-md-4">
                                                        <a
                                                            className="lightbox"
                                                            data-fancybox="gallery"
                                                            href="../assets/images/dept-sports/facilities/sp-013.jpg"
                                                        >
                                                            <img
                                                                src="../assets/images/dept-sports/facilities/sp-013.jpg"
                                                                className="img-fluid"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                    <div className="col-sm-12 col-md-4">
                                                        <a
                                                            className="lightbox"
                                                            data-fancybox="gallery"
                                                            href="../assets/images/dept-sports/facilities/sp-014.jpg"
                                                        >
                                                            <img
                                                                src="../assets/images/dept-sports/facilities/sp-014.jpg"
                                                                className="img-fluid"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                    <div className="col-sm-12 col-md-4">
                                                        <a
                                                            className="lightbox"
                                                            data-fancybox="gallery"
                                                            href="../assets/images/dept-sports/facilities/sp-015.jpg"
                                                        >
                                                            <img
                                                                src="../assets/images/dept-sports/facilities/sp-015.jpg"
                                                                className="img-fluid"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                    <div className="col-sm-12 col-md-4">
                                                        <a
                                                            className="lightbox"
                                                            data-fancybox="gallery"
                                                            href="../assets/images/dept-sports/facilities/sp-016.jpg"
                                                        >
                                                            <img
                                                                src="../assets/images/dept-sports/facilities/sp-016.jpg"
                                                                className="img-fluid"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                    <div className="col-sm-12 col-md-4">
                                                        <a
                                                            className="lightbox"
                                                            data-fancybox="gallery"
                                                            href="../assets/images/dept-sports/facilities/sp-017.jpg"
                                                        >
                                                            <img
                                                                src="../assets/images/dept-sports/facilities/sp-017.jpg"
                                                                className="img-fluid"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                    <div className="col-sm-12 col-md-4">
                                                        <a
                                                            className="lightbox"
                                                            data-fancybox="gallery"
                                                            href="../assets/images/dept-sports/facilities/sp-018.jpg"
                                                        >
                                                            <img
                                                                src="../assets/images/dept-sports/facilities/sp-018.jpg"
                                                                className="img-fluid"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                    <p>&nbsp;</p>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`tab-pane fade cash_award ${activeTab === 'tabsBtnClick5' ? 'show active' : ''}`} id="tabsBtnClick5">
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <div className="">
                                        <h3>Cash Award and Incentive</h3>
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Cash Award</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Cash Award and Incentive Session 2016-17</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/sports/Cash-Inc_2016-17.pdf"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Cash Award and Incentive Session 2017-18</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/sports/Cash-Inc_2017-18.pdf"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Cash Award and Incentive Session 2018-19 and 2019-20
                                                    </td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/sports/Cash-Inc_2018-19_2019-20.pdf"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Cash Award and Incentive Session 2018-19 and 2020-21
                                                    </td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/sports/Cash-Inc_2020-21.pdf"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`tab-pane fade annual_report ${activeTab === 'tabsBtnClick6' ? 'show active' : ''}`} id="tabsBtnClick6">
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <div className="">
                                        <h3>Annual Report</h3>
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Annual Report Department</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Annual Report Department of Sports 2016-17</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/sports/annual-report-sports_2016-17.pdf"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Annual Report Department of Sports 2017-18</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/sports/annual-report-sports_2017-18.pdf"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Annual Report Department of Sports 2018-19</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/sports/annual-report-sports_2018-19.pdf"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Annual Report Department of Sports 2019-20, 2020-21</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/sports/annual-report-sports_2019-20_%202020-21.pdf"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`tab-pane fade archery_gallery ${activeTab === 'tabsBtnClick7' ? 'show active' : ''}`} id="tabsBtnClick7">
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <div className="">
                                        <h4>Archery</h4>
                                        <hr />
                                        <div className="tz-gallery">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/archery/gallery-Archery-01.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/archery/gallery-Archery-01.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/archery/gallery-Archery-02.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/archery/gallery-Archery-02.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/archery/gallery-Archery-03.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/archery/gallery-Archery-03.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/archery/gallery-Archery-04.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/archery/gallery-Archery-04.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/archery/gallery-Archery-05.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/archery/gallery-Archery-05.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/archery/gallery-Archery-06.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/archery/gallery-Archery-06.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-md-6">
                                                    <h4>Video</h4>
                                                    <div className="ds-video">
                                                        <video width="100%" height={315} controls="">
                                                            <source
                                                                src="https://www.ccsuniversity.ac.in/ccsum/sports/videos/archery.mp4"
                                                                type="video/mp4"
                                                            />
                                                        </video>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h4>Athletics</h4>
                                        <hr />
                                        <div className="tz-gallery">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/athletics/gallery-Athletics-01.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/athletics/gallery-Athletics-01.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/athletics/gallery-Athletics-02.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/athletics/gallery-Athletics-02.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/athletics/gallery-Athletics-03.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/athletics/gallery-Athletics-03.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/athletics/gallery-Athletics-04.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/athletics/gallery-Athletics-04.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/athletics/gallery-Athletics-05.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/athletics/gallery-Athletics-05.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/athletics/gallery-Athletics-06.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/athletics/gallery-Athletics-06.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-md-6">
                                                    <h4>Video</h4>
                                                    <div className="ds-video">
                                                        <video width="100%" height={315} controls="">
                                                            <source
                                                                src="https://www.ccsuniversity.ac.in/ccsum/sports/videos/athletics.mp4"
                                                                type="video/mp4"
                                                            />
                                                        </video>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h4>Boxing</h4>
                                        <hr />
                                        <div className="tz-gallery">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/boxing/gallery-box-01.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/boxing/gallery-box-01.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/boxing/gallery-box-02.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/boxing/gallery-box-02.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/boxing/gallery-box-03.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/boxing/gallery-box-03.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-md-6">
                                                    <h4>Video</h4>
                                                    <div className="ds-video">
                                                        <video width="100%" height={315} controls="">
                                                            <source
                                                                src="https://www.ccsuniversity.ac.in/ccsum/sports/videos/boxing-24.mp4"
                                                                type="video/mp4"
                                                            />
                                                        </video>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h4>Gym</h4>
                                        <hr />
                                        <div className="tz-gallery">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-3">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gym/gallery-gym-01.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gym/gallery-gym-01.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-3">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gym/gallery-gym-02.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gym/gallery-gym-02.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-3">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gym/gallery-gym-03.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gym/gallery-gym-03.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-3">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gym/gallery-gym-04.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gym/gallery-gym-04.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-md-3">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gym/gallery-gym-05.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gym/gallery-gym-05.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-3">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gym/gallery-gym-06.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gym/gallery-gym-06.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-3">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gym/gallery-gym-07.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gym/gallery-gym-07.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-3">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gym/gallery-gym-08.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gym/gallery-gym-08.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-md-3">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gym/gallery-gym-09.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gym/gallery-gym-09.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-3">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gym/gallery-gym-010.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gym/gallery-gym-010.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-3">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gym/gallery-gym-011.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gym/gallery-gym-011.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-3">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gym/gallery-gym-012.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gym/gallery-gym-012.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-md-3">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gym/gallery-gym-013.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gym/gallery-gym-013.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-3">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gym/gallery-gym-014.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gym/gallery-gym-014.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-3">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gym/gallery-gym-015.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gym/gallery-gym-015.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-3">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gym/gallery-gym-016.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gym/gallery-gym-016.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-md-3">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gym/gallery-gym-017.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gym/gallery-gym-017.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-3">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gym/gallery-gym-018.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gym/gallery-gym-018.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-3">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gym/gallery-gym-019.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gym/gallery-gym-019.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <h4>Judo</h4>
                                        <hr />
                                        <div className="tz-gallery">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/judo/gallery-judo-01.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/judo/gallery-judo-01.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/judo/gallery-judo-02.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/judo/gallery-judo-02.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/judo/gallery-judo-03.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/judo/gallery-judo-03.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-md-6">
                                                    <h4>Video</h4>
                                                    <div className="ds-video">
                                                        <video width="100%" height={315} controls="">
                                                            <source
                                                                src="https://www.ccsuniversity.ac.in/ccsum/sports/videos/judo.mp4"
                                                                type="video/mp4"
                                                            />
                                                        </video>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h4>Kabaddi</h4>
                                        <hr />
                                        <div className="tz-gallery">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/kabaddi/gallery-Kabaddi-01.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/kabaddi/gallery-Kabaddi-01.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/kabaddi/gallery-Kabaddi-02.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/kabaddi/gallery-Kabaddi-02.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/kabaddi/gallery-Kabaddi-03.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/kabaddi/gallery-Kabaddi-03.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-md-6">
                                                    <h4>Video</h4>
                                                    <div className="ds-video">
                                                        <video width="100%" height={315} controls="">
                                                            <source
                                                                src="https://www.ccsuniversity.ac.in/ccsum/sports/videos/kabaddi-01.mp4"
                                                                type="video/mp4"
                                                            />
                                                        </video>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-6">
                                                    <h4>&nbsp;</h4>
                                                    <div className="ds-video">
                                                        <video width="100%" height={315} controls="">
                                                            <source
                                                                src="https://www.ccsuniversity.ac.in/ccsum/sports/videos/kabaddi-02.mp4"
                                                                type="video/mp4"
                                                            />
                                                        </video>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h4>MOU</h4>
                                        <hr />
                                        <div className="tz-gallery">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/mou/gallery-mou-01.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/mou/gallery-mou-01.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/mou/gallery-mou-02.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/mou/gallery-mou-02.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/mou/gallery-mou-03.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/mou/gallery-mou-03.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/mou/gallery-mou-04.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/mou/gallery-mou-04.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/mou/gallery-mou-05.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/mou/gallery-mou-05.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/mou/gallery-mou-06.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/mou/gallery-mou-06.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <h4>Shooting</h4>
                                        <hr />
                                        <div className="tz-gallery">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/shooting/gallery-shoot-01.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/shooting/gallery-shoot-01.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/shooting/gallery-shoot-02.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/shooting/gallery-shoot-02.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/shooting/gallery-shoot-03.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/shooting/gallery-shoot-03.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-md-6">
                                                    <h4>Video</h4>
                                                    <div className="ds-video">
                                                        <video width="100%" height={315} controls="">
                                                            <source
                                                                src="https://www.ccsuniversity.ac.in/ccsum/sports/videos/shooting.mp4"
                                                                type="video/mp4"
                                                            />
                                                        </video>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h4>Wrestling</h4>
                                        <hr />
                                        <div className="tz-gallery">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/wrestling/gallery-wrestling-01.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/wrestling/gallery-wrestling-01.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/wrestling/gallery-wrestling-02.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/wrestling/gallery-wrestling-02.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/wrestling/gallery-wrestling-03.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/wrestling/gallery-wrestling-03.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-md-6">
                                                    <h4>Video</h4>
                                                    <div className="ds-video">
                                                        <video width="100%" height={315} controls="">
                                                            <source
                                                                src="https://www.ccsuniversity.ac.in/ccsum/sports/videos/wrestling.mp4"
                                                                type="video/mp4"
                                                            />
                                                        </video>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h4>Weight Lifting</h4>
                                        <hr />
                                        <div className="tz-gallery">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/weight-lifting/gallery-Weight-Lifting-01.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/weight-lifting/gallery-Weight-Lifting-01.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/weight-lifting/gallery-Weight-Lifting-02.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/weight-lifting/gallery-Weight-Lifting-02.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/weight-lifting/gallery-Weight-Lifting-03.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/weight-lifting/gallery-Weight-Lifting-03.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/weight-lifting/gallery-Weight-Lifting-04.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/weight-lifting/gallery-Weight-Lifting-04.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/weight-lifting/gallery-Weight-Lifting-05.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/weight-lifting/gallery-Weight-Lifting-05.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/weight-lifting/gallery-Weight-Lifting-06.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/weight-lifting/gallery-Weight-Lifting-06.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/weight-lifting/gallery-Weight-Lifting-07.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/weight-lifting/gallery-Weight-Lifting-07.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/weight-lifting/gallery-Weight-Lifting-09.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/weight-lifting/gallery-Weight-Lifting-09.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/weight-lifting/gallery-Weight-Lifting-010.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/weight-lifting/gallery-Weight-Lifting-010.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-md-6">
                                                    <h4>Video</h4>
                                                    <div className="ds-video">
                                                        <video width="100%" height={315} controls="">
                                                            <source
                                                                src="https://www.ccsuniversity.ac.in/ccsum/sports/videos/weight-lifting.mp4"
                                                                type="video/mp4"
                                                            />
                                                        </video>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`tab-pane fade ${activeTab === 'tabsBtnClick8' ? 'show active' : ''}`} id="tabsBtnClick8">
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <h3>Achievements</h3>
                                    <div className="achivements-table">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>All India Inter University Medals</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>All India Inter University Medals 2016-17</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/05/debt-sports-Achievments-2016-17.pdf"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>All India Inter University Medals 2017-18</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/05/debt-sports-Achievments-2017-18.pdf"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>All India Inter University Medals 2018-19</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/05/debt-sports-Achievments-2018-19.pdf"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>All India Inter University Medals 2019-20</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/05/debt-sports-Achievments-2019-20.pdf"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`tab-pane fade ${activeTab === 'tabsBtnClick9' ? 'show active' : ''}`} id="tabsBtnClick9">
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <div className="">
                                        <h3>Time Table</h3>
                                        <p>This page is being uploaded...</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`tab-pane fade ${activeTab === 'tabsBtnClick10' ? 'show active' : ''}`} id="tabsBtnClick10">
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <div className="">
                                        <h3>Mou</h3>
                                        <div className="tz-gallery">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gallery/gallery-mou-01.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gallery/gallery-mou-01.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gallery/gallery-mou-02.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gallery/gallery-mou-02.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gallery/gallery-mou-03.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gallery/gallery-mou-03.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gallery/gallery-mou-04.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gallery/gallery-mou-04.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gallery/gallery-mou-05.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gallery/gallery-mou-05.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <a
                                                        className="lightbox"
                                                        data-fancybox="gallery"
                                                        href="../assets/images/dept-sports/gallery/gallery-mou-06.jpg"
                                                    >
                                                        <img
                                                            src="../assets/images/dept-sports/gallery/gallery-mou-06.jpg"
                                                            alt=""
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`tab-pane fade ${activeTab === 'tabsBtnClick11' ? 'show active' : ''}`} id="tabsBtnClick11">
                            <div className="row">
                                <div className="col-md-6 col-6">
                                    <div className="">
                                        <h3>News</h3>
                                        <div className="ds-video">
                                            <video width="100%" height={315} controls="">
                                                <source
                                                    src="https://www.ccsuniversity.ac.in/ccsum/sports/videos/ccsum-sports-main.mp4"
                                                    type="video/mp4"
                                                />
                                            </video>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`tab-pane fade ${activeTab === 'tabsBtnClick12' ? 'show active' : ''}`} id="tabsBtnClick12">
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <div className="">
                                        <h3>Sports Council</h3>
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Sports Council</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Sports Council 2016-17</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/sports/Sports-Council-2016-17.pdf"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Sports Council 2017-18</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/sports/Sports-Council-2017-18.pdf"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Sports Council 2018-19</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/sports/Sports-Council-2018-19.pdf"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Sports Council 2019-20</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/sports/Sports-Council-2019-20.pdf"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Sports Council 2020-21</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/sports/Sports-Council-2020-21.pdf"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Sports Council 2021-22</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/sports/Sports-Council-2021-22.pdf"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Other tab contents */}
                        {/* Add content for other tabs following the same structure inside the `tab-content` div */}
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;